



// document.addEventListener("DOMContentLoaded", function () {
//   const accordionItemHeaders = document.querySelectorAll(".faq_question");

//   // Expand the first accordion item by default
//   if (accordionItemHeaders.length > 0) {
//     accordionItemHeaders[0].classList.add("active");
//     const firstAccordionItemBody = accordionItemHeaders[0].nextElementSibling;
//     firstAccordionItemBody.style.maxHeight = firstAccordionItemBody.scrollHeight + "px";
//   }

//   accordionItemHeaders.forEach((accordionItemHeader) => {
//     accordionItemHeader.addEventListener("click", (event) => {
//       const currentlyActiveAccordionItemHeader = document.querySelector(".faq_question.active");
//       if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
//         currentlyActiveAccordionItemHeader.classList.toggle("active");
//         currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
//       }
//       accordionItemHeader.classList.toggle("active");
//       const accordionItemBody = accordionItemHeader.nextElementSibling;
//       if (accordionItemHeader.classList.contains("active")) {
//         accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
//       } else {
//         accordionItemBody.style.maxHeight = 0;
//       }
//     });
//   });
// });
document.addEventListener("DOMContentLoaded", function () {
  const accordionItemHeaders = document.querySelectorAll(".faq_question");

  // Expand the first accordion item by default
  if (accordionItemHeaders.length > 0) {
    accordionItemHeaders[0].classList.add("active");
    const firstAccordionItemBody = accordionItemHeaders[0].nextElementSibling;
    firstAccordionItemBody.style.maxHeight = firstAccordionItemBody.scrollHeight + "px";
  }

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(".faq_question.active");
      if (currentlyActiveAccordionItemHeader && currentlyActiveAccordionItemHeader !== accordionItemHeader) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });

    // Add CSS transition property for smoother animation
    accordionItemHeader.nextElementSibling.style.transition = "max-height 1s ease-in-out .4s"; // Adjust the duration as needed
  });
});

// --------------------------------------------------------------font animation -------------------------------

// let questions = document.querySelectorAll(".faq_question");

//       questions.forEach((question) => {
//         let icon = question.querySelector(".icon-shape");

//         question.addEventListener("click", (event) => {
//           const active = document.querySelector(".faq_question.active");
//           const activeIcon = document.querySelector(".icon-shape.active");

//           if (active && active !== question) {
//             active.classList.toggle("active");
//             activeIcon.classList.toggle("active");
//             active.nextElementSibling.style.maxHeight = 0;
//           }

//           question.classList.toggle("active");
//           icon.classList.toggle("active");

//           const answer = question.nextElementSibling;

//           if (question.classList.contains("active")) {
//             answer.style.maxHeight = answer.scrollHeight + "px";
//           } else {
//             answer.style.maxHeight = 0;
//           }
//         });
//       });




function newArrivalMobile(){
  // x.toggle.classList("swipe")
  const newArrival = document.querySelector(".new-arrival-category");
      newArrival.classList.toggle("open");
}

function shopMobile(){
  // x.toggle.classList("swipe")
  const newArrival = document.querySelector(".shop-by-category");
      newArrival.classList.toggle("open");
}

function brandsMobile(){
  // x.toggle.classList("swipe")
  const brands = document.querySelector(".brands-category");
      brands.classList.toggle("open");
}

function clothingMobile(){
  // x.toggle.classList("swipe")
  const clothing = document.querySelector(".clothing-by-category");
      clothing.classList.toggle("open");
}

function accessoriesMobile(){
  // x.toggle.classList("swipe")
  const accessories = document.querySelector(".accessories-by-category");
      accessories.classList.toggle("open");
}

function collectionMobile(){
  // x.toggle.classList("swipe")
  const collection = document.querySelector(".collection-by-category");
      collection.classList.toggle("open");
}



   // $( document ).ready(function() {
        
   //      Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
   //          get: function () {
   //              return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
   //          }
   //      });
   //              $('body').on('click touchstart', function () {
   //                  const videoElement = document.getElementById('hero-img1');
   //                  if (videoElement.playing) {
   //                      // video is already playing so do nothing
   //                  }
   //                  else {
   //                      // video is not playing
   //                      // so play video now
   //                      videoElement.play();
   //                  }
   //          });



   //    $('body').on('click touchstart', function () {
   //                  const videoElement3 = document.getElementById('posterVideo');
   //                  if (videoElement3.playing) {
   //                      // video is already playing so do nothing
   //                  }
   //                  else {
   //                      // video is not playing
   //                      // so play video now
   //                      videoElement3.play();
   //                  }
   //          });
   //      }); 
